import React, {useImperativeHandle, useRef, useState} from "react";
import Login from "../login/login";
import SignIn from "../signin/signin";
import ForgotPassword from "../forgotPassword/forgotPassword";

type ModalApi = {
    openModal: (page?: string) => void;
}

type Props = {
    onClose?: () => void;
    onFinishLogin?: () => void;
}

const LoginHome = React.forwardRef<ModalApi, Props>((props, ref) => {

    const {onClose, onFinishLogin} = props;

    const closeModalButton = useRef<HTMLButtonElement>(null);
    const [currentPage, setCurrentPage] = useState("login");

    function openModal(page = "login") {
        setCurrentPage(page);
    }

    useImperativeHandle(ref, () => ({
        // Method to save the role that is being edited
        openModal: (page = "login") => {
            return openModal(page);
        },
    }));

    function closeModal() {
        onClose?.();
        closeModalButton.current?.click();
    }

    function handleFinishLogin() {
        if(onFinishLogin){
            onFinishLogin();
        } else {
            closeModal();
        }
    }

    return (
        <div id="loginHomeModal">
            <button type="button" style={{display: 'none'}} data-bs-dismiss="modal"
                    aria-label="Close" ref={closeModalButton}></button>
            <div className="modal-header d-flex flex-row flex-wrap justify-content-center">
                {currentPage === "login" &&
                    <h3 className="modal-title">Iniciar Sesión</h3>}
                {currentPage === "signUp" &&
                    <h3 className="modal-title">Crear Cuenta</h3>}
                {currentPage === "recoverPass" &&
                    <h3 className="modal-title">Recuperar Contraseña</h3>}
                <button type="button" className="btn-close" onClick={closeModal}></button>
            </div>
            <div className="modal-body">
                {currentPage === "login" &&
                    <Login setCurrentPage={setCurrentPage} onFinishLogin={handleFinishLogin}/>}
                {currentPage === "signUp" &&
                    <SignIn setCurrentPage={setCurrentPage} onFinishLogin={handleFinishLogin}/>}
                {currentPage === "recoverPass" &&
                    <ForgotPassword setCurrentPage={setCurrentPage}/>}
            </div>
            <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={closeModal}>
                    Cancelar
                </button>
            </div>
        </div>
    )
});

export default LoginHome;
